import { render, staticRenderFns } from "./modalQR.vue?vue&type=template&id=b788ee8c"
import script from "./modalQR.vue?vue&type=script&lang=js"
export * from "./modalQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports